module.exports = __webpack_public_path__ + "static/bootstrapv5newlogo-53b9bcb3316c3cd8dbb72f21c961860a.png";